import {
  Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead,
  TablePagination, TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import DSR_Services from "../../../Services/Reports/DSR_Services"
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  border: " 1px solid black",
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
}));

function DSR2() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",fontFamily: 'Times New Roman',
  };
  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [FilteredDetails, setFilteredDetails] = useState([])
  const [showProcs, setshowProcs] = useState(false)
  const [reportProcs, setreportProcs] = useState(false)
  const [clearProcs, setclearProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [dsr2Values, setdsr2Values] = useState({
    from: getDate(),
    to: getDate(),
    branch: '-1',
    customer: '-1',
    operation: '-1',
  });
  const fromhandlechange = (e) => {
    setdsr2Values({ ...dsr2Values, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setdsr2Values({ ...dsr2Values, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setdsr2Values({ ...dsr2Values, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const customerhandlechange = (e) => {
    setdsr2Values({ ...dsr2Values, customer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const operationhandlechange = (e) => {
    setdsr2Values({ ...dsr2Values, operation: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  //getfunction
  const getfunctions = () => {
    DSR_Services.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    DSR_Services.getCustomerBasedCustomerType('Importer').then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations===>
  const showBtnClick = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    setdetails3([])
    setFilteredDetails([])
    var importer_iec_no, regionalId, operationType = '';
    if (dsr2Values.customer === 'ALL') {
      importer_iec_no = '-1'
    } else {
      importer_iec_no = dsr2Values.customer
    }
    if (dsr2Values.branch === 'ALL') {
      regionalId = '-1'
    } else {
      regionalId = dsr2Values.branch
    }
    if (dsr2Values.operation === 'ALL') {
      operationType = '-1'
    } else {
      operationType = dsr2Values.operation
    }
    let details = {
      fromDate: dsr2Values.from, toDate: dsr2Values.to, importer_iec_no: importer_iec_no, regionalId: regionalId, operationType: operationType,
      transitTypeId: '-1', customId: '-1', clearanceStatus: '-1', employeeId: '-1'
    }
    DSR_Services.getDSR_Report2(details.fromDate, details.toDate, details.importer_iec_no, details.transitTypeId, details.customId,
      details.clearanceStatus, details.regionalId, details.employeeId, details.operationType).then(res => {
        const data = res.data;
        const details = data.map((item) => item);
        if (details[0] === [] || !details[0]) {
          setMessage('No Record Found');
          setseverit('warning')
          setOpen(true)
          setshowProcs(false)
          setloading(false)
        } else
          setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }).catch(error => {
        setshowProcs(false)
        setloading(false)
      })
  }
  const reportBtnClick = () => {
    setreportProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].businessPgm !== '') {
          tableContent = details3[i].businessPgm + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].licenceNo !== '') {
          tableContent += details3[i].licenceNo + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].BOENo !== '') {
          tableContent += details3[i].BOENo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beType !== '') {
          tableContent += details3[i].beType + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].entryTypeDesc !== '') {
          tableContent += details3[i].entryTypeDesc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].endUseCode !== '') {
          tableContent += details3[i].endUseCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawbDate !== '') {
          tableContent += details3[i].hawbDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].preAlert !== '') {
          tableContent += details3[i].preAlert + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igmDate !== '') {
          tableContent += details3[i].igmDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].BOEDate !== '') {
          tableContent += details3[i].BOEDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].oocReleaseDate !== '') {
          tableContent += details3[i].oocReleaseDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].examDate !== '') {
          tableContent += details3[i].examDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].transitTypeName !== '') {
          tableContent += details3[i].transitTypeName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].vesselName !== '') {
          tableContent += details3[i].vesselName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].carrierCode !== '') {
          tableContent += details3[i].carrierCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invValue !== '') {
          tableContent += details3[i].invValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].currency_code !== '') {
          tableContent += details3[i].currency_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].grossWt !== '') {
          tableContent += details3[i].grossWt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].noPkg !== '') {
          tableContent += details3[i].noPkg + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].unitCode !== '') {
          tableContent += details3[i].unitCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].originCountry !== '') {
          tableContent += details3[i].originCountry + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].desCountry !== '') {
          tableContent += details3[i].desCountry + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawbNo !== '') {
          tableContent += details3[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawb_no !== '') {
          tableContent += details3[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].terms_code !== '') {
          tableContent += details3[i].terms_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].port !== '') {
          tableContent += details3[i].port + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cusHouseCode !== '') {
          tableContent += details3[i].cusHouseCode + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].cargoLoc !== '') {
          tableContent += details3[i].cargoLoc + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].senderName !== '') {
          tableContent += details3[i].senderName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].receiverName !== '') {
          tableContent += details3[i].receiverName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].manufactureName !== '') {
          tableContent += details3[i].manufactureName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_iec_no !== '') {
          tableContent += details3[i].importer_iec_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].relParty !== '') {
          tableContent += details3[i].relParty + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      let details = {
        headerName: "0,0,.", headerDetails: "1,1,.",
        tableHeader: "0,0,Business Programme/1,0,Broker LicenceNo/2,0,BE NUMBER/3,0,JOB_NO/4,0,BoE Type HC_WH/5,0,Entry Type Description/6,0,End Use Product Code/7,0,AWB_HBL date i.e Shipment departure date/8,0,Date of receipt of pre alert docs from Forwarder/9,0,Date of Arrival IGM Date_Inward Date/10,0,BoE filing Date/11,0,OOC Release Date/12,0,Customs Exam Date If applicable/13,0,Mode of Transportation Sea_Air/14,0,Vessel Name/15,0,Carrier Code/16,0,Total Invoice Value/17,0,Value Currency/18,0,Gross weight in Kgs three decimals/19,0,No of Pkgs/20,0,Type of Pkgs/21,0,Country of Export/22,0,Country of Destination/23,0,Master Bill of Lading_MAWB Number/24,0,House Bill of Lading_HAWB Number/25,0,Terms of Import_Incoterms/26,0,Place of departure_Port of Loading/27,0,Port of Entry Customs Port Code/28,0,Cargo Location/29,0,Name of Shipper/30,0,Name of Consignee/31,0,Manufacturer or Supplier ID or Name/32,0,IOR_IEC_Branch Code/33,0,Related Party Y_N/34,0,In Bond Y_N/35,0,Customs Examination Y_N/36,0,Broker Fee/37,0,Broker Fee Currency/38,0,Demurrage Charges/39,0,Demurrage Charges Currency/40,0,Late Presentation charges/41,0,Late Presentation Charges Currency/42,0,Interest Amount/43,0,Interest Currency/44,0,Exam Fee/45,0,Exam Fee Currency/46,0,Import Fee 1/47,0,Import Fee 1 Currency/48,0,Import Fee 2/49,0,Import Fee 2 Currency/50,0,Import Fee 3/51,0,Import Fee 3 Currency/52,0,Line Number_Serial Number of Invoice/53,0,P.O. No./54,0,Invoice Number/55,0,Supplier's Name address/56,0,Item Number_ASIN Number (in Description)/57,0,Description of Goods/58,0,HS Code/59,0,Country of Origin/60,0,Quantity/61,0,UOM/62,0,Unit Quantity/63,0,Invoice Value/64,0,Invoice Currency/65,0,Invoice Unit Price/66,0,Invoice Unit Currency/67,0,Assessable Value/68,0,Assessable Value Currency/69,0,Duty Amount/70,0,Duty Amount Currency INR/71,0,Duty Rate %/72,0,Overseas Freight Amount/73,0,Overseas Freight Amount Currency/74,0,Origin Freight Amount Charges/75,0,Origin Freight Amount Currency/76,0,Destination Freight Amount/77,0,Destination Freight Amount Currency/78,0,Insurance Amount/79,0,Insurance Currency/80,0,Royalty Amount/81,0,Royalty Amount Currency/82,0,Contra Cogs Amount/83,0,Congra Cogs Currency/84,0,Discount Amount/85,0,Discount Currency/86,0,VAT Amount/87,0,VAT Currency/88,0,VAT Rate/89,0,GST Amount/90,0,GST Currency/91,0,GST Rate/92,0,Other Tax 1 Amount of SWC/93,0,Other Tax 1 SWC Currency/94,0,Other Tax 1 SWC Rate/95,0,Other Tax 2 Amount/96,0,Other Tax 2 Currency/97,0,Other Tax 2 Rate/98,0,Exchange Rate/99,0,BCD Notification No & Sl No./100,0,Tariff Supplement/101,0,Import License Number/102,0,PGA Code1/103,0,PGA Code2/104,0,ADD Notification Sl No./105,0,CVD Notification Sl No./106,0,Anti dumping Duty/107,0,ADD Currency/108,0,Counterveiling Duty Amount/109,0,CVD Currency/110,0,Import Product Fee 1/111,0,Import Product Fee 1 Currency/112,0,Import Product Fee 2/113,0,Import Product Fee 2 Currency/114,0,Import Product Fee 3/115,0,Import Product Fee 3 Currency",
        tableRowStartsFrom: 1, tableColumnStartsFrom: 0, fileCode: "dsr2", totalNumberOfColumn: 116, tableContent: contenall.substring(0, contenall.length - 1),
      }
      DSR_Services.writeXl(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setclearProcs(false)
  }
  const clrBtnClick = () => {
    setclearProcs(true)
    setdsr2Values({ ...dsr2Values, from: getDate(), to: getDate(), branch: '-1', customer: '-1', operation: '-1', })
    setdetails3([])
    setFilteredDetails([])
    setclearProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, [])

  //tableSearch
  const branchNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { branchNmOnchange(e.target.value) }} />
  }
  const opertionTypeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { opertionTypeOnchange(e.target.value) }} />
  }
  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { modeOnchange(e.target.value) }} />
  }
  const placeofDepSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { placeofDepOnchange(e.target.value) }} />
  }
  const cusPortCdSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { cusPortCdOnchange(e.target.value) }} />
  }
  const nameOfShipperSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { nameOfShipperOnchange(e.target.value) }} />
  }
  const nameConsigneSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { nameConsigneOnchange(e.target.value) }} />
  }
  const invoiceNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { invoiceNoOnchange(e.target.value) }} />
  }
  const itemDescSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { itemDescOnchange(e.target.value) }} />
  }
  //
  const branchNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const opertionTypeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.operationType.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitTypeName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const placeofDepOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.port.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const cusPortCdOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.cusHouseCode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const nameOfShipperOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.senderName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const nameConsigneOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.receiverName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const itemDescOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.itemDesc.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }

  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Row>
              <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}><center>DSR-2 REPORT</center></div>
              <Col></Col>
              <Col><center>
                <label style={mystyle1}>FromDate</label>
                <Form.Control size="sm" type="date" style={mystyle} value={dsr2Values.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>ToDate</label>
                  <Form.Control size="sm" type="date" style={mystyle} value={dsr2Values.to} onChange={tohandlechange} /></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>Branch</label>
                  <Form.Select size="sm" style={mystyle} value={dsr2Values.branch} onChange={branchhandlechange}>
                    {details1.map(trns => (
                      <option value={trns.regionId}>{trns.regionalName}</option>
                    ))}
                  </Form.Select></center>
              </Col>
              <Col>
                <center><label style={mystyle1}>Customer</label>
                  <Form.Select type="text" list="code" style={mystyle} size="sm" value={dsr2Values.customer} onChange={customerhandlechange}>
                    <option value={'-1'}>ALL</option>
                    {details2.map(trns => (
                      <option value={trns.importer_iec_no}>{trns.importer_name}</option>
                    ))}
                  </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Operation</label>
                <Form.Select size="sm" style={mystyle} value={dsr2Values.operation} onChange={operationhandlechange}>
                  <option value={'-1'}>ALL</option>
                  <option value={'IMPORT'}>IMPORT</option>
                  <option value={'EXPORT'}>EXPORT</option>
                  <option value={'COURIER'}>COURIER</option>
                </Form.Select></center>
              </Col>
              <Col></Col>
            </Row>
            <br></br>
            <Row className="mb-1">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="success" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={showBtnClick}>{showProcs ? 'processing...' : 'Show'}</Button>
                &nbsp;
                <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={reportBtnClick}> {reportProcs ? 'processing...' : 'Report'}  </Button>
                &nbsp;
                <Button variant="warning" style={{ fontFamily: 'Times New Roman'}}size="sm" onClick={clrBtnClick}> {clearProcs ? 'processing...' : 'Clear'} </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 420 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>BranchName{branchNmSrch()}</StyledTableCell>
                      <StyledTableCell>OperationType{opertionTypeSrch()}</StyledTableCell>
                      <StyledTableCell>BrokerLicenseNo</StyledTableCell>
                      <StyledTableCell>BE/SBNo</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobDate</StyledTableCell>
                      <StyledTableCell>BE/SBType</StyledTableCell>
                      <StyledTableCell>BE/SBDate</StyledTableCell>
                      <StyledTableCell>Mode{modeSrch()}</StyledTableCell>
                      <StyledTableCell>IGM/InwardDate</StyledTableCell>
                      <StyledTableCell>AWB/HBLDate</StyledTableCell>
                      <StyledTableCell>EndUseCode</StyledTableCell>
                      <StyledTableCell>InvoiceValue</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>NoofPkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>Terms</StyledTableCell>
                      <StyledTableCell>PlaceofDeparture{placeofDepSrch()}</StyledTableCell>
                      <StyledTableCell>CustomPortCode{cusPortCdSrch()}</StyledTableCell>
                      <StyledTableCell>IEC/BranchCode</StyledTableCell>
                      <StyledTableCell>NameofShipper{nameOfShipperSrch()}</StyledTableCell>
                      <StyledTableCell>NameofConsignee{nameConsigneSrch()}</StyledTableCell>
                      <StyledTableCell>InvoiceNo{invoiceNoSrch()}</StyledTableCell>
                      <StyledTableCell>SupplierAddress</StyledTableCell>
                      <StyledTableCell>ItemNo</StyledTableCell>
                      <StyledTableCell>ItemDescription{itemDescSrch()}</StyledTableCell>
                      <StyledTableCell>HSCode</StyledTableCell>
                      <StyledTableCell>CountryOfOrigin</StyledTableCell>
                      <StyledTableCell>Qty</StyledTableCell>
                      <StyledTableCell>Unit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.licenceNo}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeENo}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitDate}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beType}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boeDate}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitTypeName}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmDate}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.endUseCode}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invValue}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noPkg}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grossWt}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.terms_code}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.port}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cusHouseCode}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_iec_no}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.senderName}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.receiverName}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNumber}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.supplierAddress}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemNo}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemDesc}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hsCode}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.countryOfOrigin}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.quantityString}</TableCell>
                          <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.unit}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default DSR2;
